module.exports = __webpack_public_path__ + "fonts/fd745f8.ttf";